// src/context/AuthContext.js

import { createContext, useContext, useState, useEffect } from "react";
import { onAuthChange, logoutUser } from "../firebase/auth";
import { getStudent } from "../firebase/database";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [userData, setUserData] = useState(null);
  const [profile, setProfile]   = useState(null);
  const [ready, setReady]     = useState(false);

  useEffect(() => {
    const unsub = onAuthChange(async (u, data) => {
      setUser(u);
      setUserData(data);
      
      if (data?.studentId) {
        const p = await getStudent(data.studentId);
        setProfile(p);
      } else {
        setProfile(null);
      }
      
      setReady(true);
    });
    return unsub;
  }, []);

  const logout = () => logoutUser();
  const role = userData?.role;

  return (
    <AuthContext.Provider value={{ user, userData, profile, role, ready, logout,
      isAdmin:   role === "admin",
      isTrainer: role === "trainer" || role === "admin",
      isInstructor: role === "instructor" || role === "admin" || role === "trainer",
      isStudent: role === "student",
      isLimitedStaff: role === "staff_limited",
      studentId: userData?.studentId,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
